<template>
  <div class="text-center">
    <v-dialog v-model="showForm" width="500" persistent>
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{action}}
          <v-spacer></v-spacer>
          <v-btn icon @click="$emit('closeDialog')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-form ref="form" v-model="form" @submit.prevent="submit">
          <v-card-text class="pb-0">
            <v-text-field
              label="Vessel Name"
              placeholder="Enter Vessel Name"
              :rules="[rules.required]"
              outlined
              dense
              v-model="vesselForm.name"
              prepend-inner-icon="mdi-ferry"
              clearable
              :disabled="!['operations'].includes($store.state.auth.profile.role) ? false : !!vesselForm.id"
            ></v-text-field>
            <v-text-field
              label="Vessel Type"
              placeholder="Enter Vessel Type"
              :rules="[rules.required]"
              outlined
              dense
              v-model="vesselForm.vessel_type"
              prepend-inner-icon="mdi-apple-safari"
              clearable
              :disabled="!['operations'].includes($store.state.auth.profile.role) ? false : !!vesselForm.id"
            ></v-text-field>
            <v-text-field
              label="IMO Number"
              placeholder="Enter IMO Number"
              :rules="[rules.required]"
              outlined
              dense
              v-model="vesselForm.imo_number"
              prepend-inner-icon="mdi-numeric"
              clearable
              :disabled="!['operations'].includes($store.state.auth.profile.role) ? false : !!vesselForm.id"
            ></v-text-field>
            <v-text-field
              label="Call Sign"
              placeholder="Enter Call Sign"
              :rules="[rules.required]"
              outlined
              dense
              v-model="vesselForm.call_sign"
              prepend-inner-icon="mdi-forward"
              clearable
              :disabled="!['operations'].includes($store.state.auth.profile.role) ? false : !!vesselForm.id"
            ></v-text-field>
            <v-text-field
              label="Flag"
              placeholder="Enter Flag"
              :rules="[rules.required]"
              outlined
              dense
              v-model="vesselForm.flag"
              prepend-inner-icon="mdi-flag"
              clearable
              :disabled="!['operations'].includes($store.state.auth.profile.role) ? false : !!vesselForm.id"
            ></v-text-field>
            <!-- <v-text-field
              label="Parent Company"
              placeholder="Enter Parent Company"
              outlined
              dense
              v-model="vesselForm.parent_company"
              prepend-inner-icon="mdi-office-building"
              clearable
            ></v-text-field> -->
            <v-select
              label="Principal"
              placeholder="Select Principal"
              outlined
              dense
              multiple
              :items="filteredPricipal"
              :rules="[rules.required]"
              v-model="vesselForm.principal"
              prepend-inner-icon="mdi-account"
              item-text="name"
              item-value="id"
            >
              <template v-slot:prepend-item>
                <v-text-field
                  v-model="principalSearchQuery"
                  prepend-inner-icon="mdi-magnify"
                  placeholder="Search..."
                  clearable
                  class="px-4"
                  @input="filterPricipal"
                ></v-text-field>
              </template>
            </v-select>
            <v-text-field
              label="Registered Ownership"
              placeholder="Enter Registered Ownership"
              :rules="[rules.required]"
              outlined
              dense
              v-model="vesselForm.registered_ownership"
              prepend-inner-icon="mdi-comment-account"
              clearable
              :disabled="!['operations'].includes($store.state.auth.profile.role) ? false : !!vesselForm.id"
            ></v-text-field>
            <v-text-field
              label="Email"
              placeholder="Enter Email Address"
              :rules="[rules.email]"
              outlined
              dense
              v-model="vesselForm.email"
              prepend-inner-icon="mdi-email"
              clearable
            ></v-text-field>
            <v-text-field
              label="Mobile"
              placeholder="Enter Mobile Number"
              :rules="[rules.mobile]"
              outlined
              dense
              v-model="vesselForm.vessel_contact"
              prepend-inner-icon="mdi-phone"
              clearable
            ></v-text-field>
            <v-select
              label="Billing Party"
              placeholder="Select Billing Party"
              outlined
              multiple
              dense
              :items="filteredOwners"
              :rules="[rules.required]"
              v-model="vesselForm.card_id"
              prepend-inner-icon="mdi-account"
              item-text="name"
              item-value="id"
            >
              <template v-slot:prepend-item>
                <v-text-field
                  v-model="ownerSearchQuery"
                  prepend-inner-icon="mdi-magnify"
                  placeholder="Search..."
                  clearable
                  class="px-4"
                  @input="filterOwners"
                ></v-text-field>
              </template>
            </v-select>
            <v-text-field
              label="Gross Tonnage"
              placeholder="Enter Gross Tonnage"
              :rules="[rules.required]"
              outlined
              dense
              v-model="vesselForm.gross_tonnage"
              prepend-inner-icon="mdi-weight"
              clearable
              :disabled="!['operations'].includes($store.state.auth.profile.role) ? false : !!vesselForm.id"
            ></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-center">
            <v-btn color="primary" outlined @click="formSubmit()" 
              :disabled="loading" :loading="loading">
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import rules from '../../../utilities/validator';

  export default {
    name: 's-vessel-manual-form',
    props: {
      action: {
        type: String,
        required: true,
      },
      owners: Array,
      principal: Array,
      showForm: {
        type: Boolean,
        default: false,
      },
      vessel: {
        type: Object,
        default: {},
      },
    },
    data() {
      let vesselInfo = {
        name: '',
        vessel_type: '',
        call_sign: '',
        imo_number: '',
        flag: '',
        registered_ownership: '',
        card_id: '',
        gross_tonnage: '',
        email: '',
        vessel_contact: '',
        parent_company: '',
        principal: []
      };

      return {
        rules,
        form: false,
        loading: false,
        searchQuery: '',
        principalSearchQuery: '',
        ownerSearchQuery: '',
        filteredOwners: this.owners,
        filteredPricipal: this.principal,
        vesselForm: Object.assign({}, vesselInfo),
      };
    },
    methods: {
      filterOwners() {
        if (!this.ownerSearchQuery) {
          this.filteredOwners = this.owners;
        } else {
          this.filteredOwners = this.owners.filter(owner =>
            owner.name.toLowerCase().includes(this.ownerSearchQuery.toLowerCase())
          );
        }
      },
      filterPricipal() {
        if (!this.principalSearchQuery) {
          this.filteredPricipal = this.principal;
        } else {
          this.filteredPricipal = this.principal.filter(principal =>
            principal.name.toLowerCase().includes(this.principalSearchQuery.toLowerCase())
          );
        }
      },
      updateVessel() {
        this.loading = true;
        // Prepare data with principal_ids
        let vesselData = Object.assign({}, this.vesselForm);
        vesselData.principal_ids = this.vesselForm.principal;
        delete vesselData.principal;
        
        this.$api.vessels.update(vesselData)
          .then((response) => {
            this.$store.dispatch('setAlert', {
              status: 'success',
              show: true,
              message: 'Vessel updated successfully',
            });
            this.$emit('formSubmitted');
          }).catch((err) => {
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          }).finally(() => (this.loading = false));
      },
      createVessel() {
        this.loading = true;
        // Prepare data with principal_ids
        let vesselData = Object.assign({}, this.vesselForm);
        vesselData.principal_ids = this.vesselForm.principal;
        delete vesselData.principal;
        
        this.$api.vessels.create(vesselData)
          .then((response) => {
            this.$store.dispatch('setAlert', {
              status: 'success',
              show: true,
              message: 'Vessel created successfully',
            });
            this.$emit('formSubmitted');
          }).catch((err) => {
            this.$store.dispatch('setAlert', {
              status: 'error',
              show: true,
              message: err.message,
            });
          }).finally(() => (this.loading = false));
      },
      formSubmit() {
        if (this.vesselForm.id) {
          this.updateVessel();
        } else {
          this.createVessel();
        }
      },
    },
    watch: {
      vessel(value) {
        if (value && value.id) {
          this.vesselForm = Object.assign({}, value);
          // Set the principal to the card IDs for the Principal dropdown (multi-select)
          if (value.principal_cards && Array.isArray(value.principal_cards)) {
            this.vesselForm.principal = value.principal_cards.map(principal => principal.id);
          } else if (value.principal) {
            this.vesselForm.principal = Array.isArray(value.principal) ? value.principal : [value.principal];
          }
          // Set the card_id for the Billing Party dropdown (multi-select)
          if (value.billing_party_cards && Array.isArray(value.billing_party_cards)) {
            this.vesselForm.card_id = value.billing_party_cards.map(party => party.id);
          } else if (value.card_id && Array.isArray(value.card_id)) {
            this.vesselForm.card_id = value.card_id.map(owner => owner.id);
          }
        }
      }
    },
    created() {
      if (this.vessel && this.vessel.id) {
        this.vesselForm = Object.assign({}, this.vessel);
        // Set the principal to the card IDs for the Principal dropdown (multi-select)
        if (this.vessel.principal_cards && Array.isArray(this.vessel.principal_cards)) {
          this.vesselForm.principal = this.vessel.principal_cards.map(principal => principal.id);
        } else if (this.vessel.principal) {
          this.vesselForm.principal = Array.isArray(this.vessel.principal) ? this.vessel.principal : [this.vessel.principal];
        }
        // Set the card_id for the Billing Party dropdown (multi-select)
        if (this.vessel.billing_party_cards && Array.isArray(this.vessel.billing_party_cards)) {
          this.vesselForm.card_id = this.vessel.billing_party_cards.map(party => party.id);
        } else if (this.vessel.card_id && Array.isArray(this.vessel.card_id)) {
          this.vesselForm.card_id = this.vessel.card_id.map(owner => owner.id);
        }
      }
    }
  };
</script>